import actions from './actions'

export default function SingleTokensReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_SINGLETOKEN:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_SINGLETOKEN:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_SINGLETOKEN:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_SINGLETOKEN:
      return {
        ...state,
        editing: { singleTokenID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_SINGLETOKEN_RECIEVED ||
      actions.UPDATE_SINGLETOKEN_RECIEVED ||
      actions.DELETE_SINGLETOKEN_RECIEVED:
      return {
        ...state,
        editing: { singleTokenID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
